// extracted by mini-css-extract-plugin
var _1 = "ApplicantIdentityWidgetMessage-modulelabel__wK02X";
export { _1 as "label" }
